/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "icc": {
            "nested": {
              "CaptureRequestIccData": {
                "fields": {
                  "transactionCertificate": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ReverseRequestIccData": {
                "fields": {
                  "applicationAuthenticationCryptogram": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "issuerScriptResults": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.icc?.nested?.CaptureRequestIccData && !$root.nested?.squareup?.nested?.payments?.nested?.icc?.nested?.ReverseRequestIccData) {
  $root.addJSON(jsonData);
}

/**
 * Fields provided by the client when capturing an ICC transaction.
 *
 * All of these fields are hex-encoded.
 *
 * SOURCE CaptureRequestIccData @ squareup/payments/icc.proto at 114:1
 */
export const CaptureRequestIccData = $root.lookupType('squareup.payments.icc.CaptureRequestIccData');
fixType(CaptureRequestIccData);
Builder.createAndAttachToType(CaptureRequestIccData);
/**
 * Fields needed to reverse an ICC transaction.
 *
 * All of these fields are hex-encoded.
 *
 * SOURCE ReverseRequestIccData @ squareup/payments/icc.proto at 127:1
 */
export const ReverseRequestIccData = $root.lookupType('squareup.payments.icc.ReverseRequestIccData');
fixType(ReverseRequestIccData);
Builder.createAndAttachToType(ReverseRequestIccData);